import MultiSelectInput from '@repo/ui/multiselect-input'
import { useQuery } from '@tanstack/react-query'

import { getPeriods } from '../../../api/periods/get-periods'
import useTranslate from '../../../lib/hooks/use-translate'
import { travelExpensesStatusEnumMapping } from '../../../lib/types/enums/affected-staff/affected-staff-status.enum'
import {
  StaffPositionEnum,
  staffPositionEnumMapping
} from '../../../lib/types/enums/staff/staff-position.enum'
import {
  StaffQualificationEnum,
  staffQualificationEnumMapping
} from '../../../lib/types/enums/staff/staff-qualifications.enum'
import { TravelExpensesStaffsFilters } from '../../../lib/types/models/travel-expenses/travel-expenses-staff'
import { defaultTravelExpensesStaffStatuses } from '../../../lib/utils/filters-mapping/travel-expenses-staff'

interface Props {
  filter?: TravelExpensesStaffsFilters
  onFilterChange: (filter: TravelExpensesStaffsFilters) => void
}

const TravelExpensesStaffFilter = ({ filter, onFilterChange }: Props) => {
  const { t } = useTranslate()

  function setFilter<K extends keyof TravelExpensesStaffsFilters>(
    key: K,
    value: TravelExpensesStaffsFilters[K]
  ) {
    onFilterChange({ ...filter, [key]: value })
  }

  const { data: periods } = useQuery({
    queryKey: ['periods', 'BASIC'],
    queryFn: () => getPeriods({ version: 'BASIC' })
  })

  return (
    <div className="flex flex-col gap-3 mt-2">
      <MultiSelectInput
        label="Statuts"
        variant="primary"
        options={defaultTravelExpensesStaffStatuses.map((status) => ({
          label: travelExpensesStatusEnumMapping[status].label,
          value: status
        }))}
        onChange={(travelExpensesStatuses) =>
          setFilter('travelExpensesStatuses', travelExpensesStatuses)
        }
        selectedOptions={filter?.travelExpensesStatuses?.map((status) => ({
          label: travelExpensesStatusEnumMapping[status].label,
          value: status
        }))}
      />

      <MultiSelectInput
        searchable
        label="Périodes"
        variant="warning"
        options={periods?.data?.map((period) => ({ label: period.name, value: period.id }))}
        onChange={(periods) => setFilter('periods', periods)}
        selectedOptions={filter?.periods?.map((periodId) => ({
          label: periods?.data?.find((p) => p.id === periodId)?.name || '',
          value: periodId
        }))}
      />

      <MultiSelectInput
        label="Poste"
        variant="primary"
        searchable
        options={Object.values(StaffPositionEnum)
          .filter((position) => position !== StaffPositionEnum.AAT)
          .map((position) => ({
            label: t(staffPositionEnumMapping[position]),
            value: position
          }))}
        onChange={(positions) => setFilter('positions', positions)}
        selectedOptions={filter?.positions?.map((position) => ({
          label: t(staffPositionEnumMapping[position]),
          value: position
        }))}
      />

      <MultiSelectInput
        label="Qualifications"
        variant="primary"
        searchable
        options={Object.values(StaffQualificationEnum).map((qualification) => ({
          label: t(staffQualificationEnumMapping[qualification].label),
          value: qualification
        }))}
        onChange={(qualifications) => setFilter('qualifications', qualifications)}
        selectedOptions={filter?.qualifications?.map((qualification) => ({
          label: t(staffQualificationEnumMapping[qualification].label),
          value: qualification
        }))}
      />
    </div>
  )
}

export default TravelExpensesStaffFilter
